import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { genericRequiredFieldError } from '../../constants';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    projectType,
    systemPowerSingleOrMultipleUsers,
    systemPowerCommunityOrPPALease,
  },
} = loanFormModel;

export class CommunityOrPPALeaseValidation implements ValidationSchema {
  public name: string = systemPowerCommunityOrPPALease.name;
  public label: string = systemPowerCommunityOrPPALease.label;
  public dependsOn: string[] = [
    projectType.name,
    systemPowerSingleOrMultipleUsers.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(projectType: string, singleOrMultipleUsers: string, schema) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return schema;
    if (singleOrMultipleUsers === 'Multiple Users') {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new CommunityOrPPALeaseValidation());
